import { useContext } from 'react';
import { ChartDefinitionsContext, DEFINITION_URLS } from '../context';

export function useChartDefinitionsContext(): typeof DEFINITION_URLS {
  const context = useContext(ChartDefinitionsContext);
  if (typeof context === 'undefined') {
    throw new Error(
      'useChartDefinitionsContext: Attempting to access undefined context, possibly outside of `ChartDefinitionsProvider`'
    );
  }
  return context;
}
